import React, { useEffect, useState } from "react";
import DashboardHeader from "../../components/auth/DashboardHeader";
import Sidebar from "../../components/auth/Sidebar";
import { Loader } from "../../components/Loader";
import API from "../../helper/AxiosInterceptor";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const TransactionView = () => {
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);



  const fetchTransactionDetails = async () => {
    try {
      setIsLoading(true);

      const resp = await API.get(
        `${process.env.REACT_APP_API_URL}/payment-link/merchant-tx-id?transactionId=${transactionId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setData(resp?.data?.data);
    } catch (error) {
      console.error("Error fetching transaction details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactionDetails();
  }, []);

  if (isLoading) return <Loader />;

  // ------------------------------
  // Dynamic Optional Rows Handling
  // ------------------------------
  const rows = data
    ? [
      { label: "ID", value: data?._id },
      { label: "Status", value: data?.status },
      { label: "Payment Type", value: data?.transactionType },
      { label: "Amount", value: data?.amount },
      { label: "Withdraw Status", value: data?.withdrawStatus },
      { label: "Type", value: data?.type },
      { label: "Symbol", value: data?.symbol },
      { label: "Crypto Amount", value: data?.cryptoAmount },
      {
        label: "Fiat Amount",
        value: data?.fiatAmount
          ? `${data?.fiatAmount} ${data?.fiatCurrency?.toUpperCase()}`
          : null,
      },
      { label: "Price Per Coin", value: data?.pricePerCoin },
      { label: "To Address", value: data?.toAddress },

      { label: "USD Amount", value: data?.usdAmount },
      { label: "Crypto To USD", value: data?.cryptoToUsd },
      { label: "Fiat To USD", value: data?.fiatToUsd },
      {
        label: "Created At",
        value: data?.createdAt
          ? new Date(data.createdAt).toLocaleString()
          : null,
      },
    ].filter(
      (row) =>
        row.value !== undefined &&
        row.value !== null &&
        row.value !== "" &&
        row.value !== "undefined"
    )
    : [];

  return (
    <>
      <DashboardHeader />

      <div className="site-bg">
        <div className="dashborad-content-bg">
          <aside className="sidebar">
            <Sidebar />
          </aside>

          <div className="dashborad-warper">
            <div className="transactions-list">
              <div className="dashborad-head">
                <div className="breadcrumb-menu">
                  <button className="back-btn" onClick={() => navigate(-1)}>
                    <i className="ti ti-arrow-left"></i>
                  </button>
                  <p>Transaction Details</p>
                </div>
              </div>

              <div className="white-bg padd20 my-apps-content tx-card">
                {data ? (
                  <div className="tx-details">
                    {rows.map((row, index) => (
                      <div className="tx-row" key={index}>
                        <span>{row.label}</span>
                        <p>{row.value}</p>
                      </div>
                    ))}

                    {/* Always show Link URL if exists */}
                    {data?.linkURL && (
                      <div className="tx-row">
                        <span>Link URL</span>
                        <a
                          href={data?.linkURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="tx-link"
                        >
                          {data?.linkURL}
                        </a>
                      </div>
                    )}
                  </div>
                ) : (
                  <p>No Transaction Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Improved Compact UI */}
      <style>{`
        .tx-card {
          border-radius: 12px;
          padding: 20px !important;
          border: 1px solid #e5e5e5;
          max-width: 700px;
        }
          .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #f0f0f0;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
          color: #333;
          margin-right: 12px;
          transition: 0.2s ease;
        }

        .back-btn i {
          font-size: 16px;
        }

        .back-btn:hover {
          background: #e1e1e1;
        }

        .tx-details {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .tx-row {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #eaeaea;
          padding: 6px 0;
        }

        .tx-row span {
          font-weight: 600;
          color: #444;
          font-size: 14px;
        }

        .tx-row p {
          margin: 0;
          font-size: 14px;
          color: #222;
          text-align: right;
        }

        .tx-link {
          color: #007bff;
          text-decoration: none;
          font-size: 14px;
        }

        .tx-link:hover {
          text-decoration: underline;
        }
      `}</style>
    </>
  );
};

export default TransactionView;
